export default "__VITE_ASSET__6qU$6kSr__"